export const IconTrendingUp = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconTrendingUp_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconTrendingUp_svg__a)">
        <path d="M2.7 17.625a.93.93 0 0 1-.288-.712.98.98 0 0 1 .288-.688l5.275-5.35Q8.55 10.3 9.4 10.3t1.425.575l2.575 2.6 5.2-5.15H17a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712q0-.424.288-.713A.97.97 0 0 1 17 6.325h4q.424 0 .712.287.288.288.288.713v4q0 .424-.288.713a.97.97 0 0 1-.712.287.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-1.6L14.825 14.9q-.575.575-1.425.575t-1.425-.575L9.4 12.325l-5.3 5.3a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275" />
      </g>
    </svg>
  );
};
